export default __webpack_public_path__ + "static/10-4d1be6b945f1f2667a3f6a7c9847c736.jpg";